module.exports = __webpack_public_path__ + "assets/img/main-logo-chengde.8fd7bc0a.png";